exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".padding[data-v-5ca56e93]{padding-top:10px;padding-bottom:10px}.full-page[data-v-5ca56e93]{height:100%;min-height:100vh;position:relative}.white-text[data-v-5ca56e93]{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ca56e93","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ManageAlbums.vue
// module id = 413
// module chunks = 0